import angular from 'angular';
import common from './core.module';
import LoginForgotController from './controllers/login/forgot.controller';
import LoginSigninController from './controllers/login/signin.controller';

const moduleName = 'atc-login';
angular.module(moduleName, [common])
    .controller('LoginForgotController', LoginForgotController)
    .controller('LoginSigninController', LoginSigninController)
;


export default moduleName;